import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography/Typography";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { SubNavigation } from "@common/Navigation/SubNavigation";
import { SelectYourNumber } from "@common/SelectYourNumber/SelectYourNumber";
import { OfferDetails } from "@features/AccountDetails/OfferDetails";
import { PinPuk } from "@features/AccountDetails/PinPuk";
import { AccountDetailsMenu } from "@features/AccountDetails/AccountDetailsMenu";
import { useGetOfferDetails } from "@features/AccountDetails/hook/useGetOfferDetails";
import { useGetAccountDetails } from "@features/AccountDetails/hook/useGetAccountDetails";
import { HandleErrorAndLoading } from "@common/handleErrorAndLoading/HandleErrorAndLoading";
import { NoServiceAccountDetailsMenu } from "@features/AccountDetails/NoServiceAccountDetailsMenu";

export const AccountDetailsPage = () => {
    const { t } = useTranslation(["navigation", "accountDetails"]);
    const {
        simCard,
        offerDetail,
        isInCollection,
        getSimCardState,
        getOfferDetailState,
        getIsInCollectionState,
    } = useGetOfferDetails();
    const { accountDetails } = useGetAccountDetails();

    return (
        <Fragment>
            <SubNavigation />
            <div className="container-boxed">
                <Typography align="center" color="secondary" paragraph variant="h1">
                    {t("navigation:accountDetails")}
                </Typography>
                {accountDetails && (
                    <Typography align="center" color="secondary" paragraph>
                        {t("accountDetails:accountIdText", { accountId: accountDetails.id })}
                    </Typography>
                )}
                <SelectYourNumber noServiceChildren={<NoServiceAccountDetailsMenu />}>
                    <Grid container direction="column" spacing={5}>
                        <HandleErrorAndLoading isLoading={getOfferDetailState.isLoading}>
                            {offerDetail ? (
                                <Grid item>
                                    <OfferDetails offerDetails={offerDetail} />
                                </Grid>
                            ) : (
                                <Grid item>
                                    <Card elevation={2}>
                                        <CardContent>
                                            <Typography align="center" color="secondary" gutterBottom variant="h4">
                                                {t("accountDetails:noActiveOffer")}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            )}
                        </HandleErrorAndLoading>
                        <HandleErrorAndLoading isLoading={getSimCardState.isLoading}>
                            {simCard ? (
                                <Grid item>
                                    <PinPuk pinNumber={simCard.pin} pukNumber={simCard.puk} />
                                </Grid>
                            ) : (
                                <Grid item>
                                    <Card elevation={2}>
                                        <CardContent>
                                            <Typography align="center" variant="body1">
                                                {t("accountDetails:noActiveOfferForPhoneNumber")}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            )}
                        </HandleErrorAndLoading>

                        <HandleErrorAndLoading isLoading={getIsInCollectionState.isLoading}>
                            <Grid item>
                                <AccountDetailsMenu
                                    hasActiveOfferDetails={Boolean(offerDetail && simCard)}
                                    isInCollection={isInCollection}
                                />
                            </Grid>
                        </HandleErrorAndLoading>
                    </Grid>
                </SelectYourNumber>
            </div>
        </Fragment>
    );
};
